module.exports = __webpack_public_path__ + "static/media/note.11d046fa.png";